import { translate } from '@teamleader/i18n';
import cx from 'classnames';
import React from 'react';

import styles from './styles.css';
import Box from '../../../../../../Components/UI/Box';
import { ProjectLine, ProjectLineStatus } from '../../../../../../Types/project';

export const STATUS_MAP: Record<ProjectLineStatus, string> = {
  [ProjectLineStatus.Todo]: 'project.status.todo',
  [ProjectLineStatus.InProgress]: 'project.status.inProgress',
  [ProjectLineStatus.OnHold]: 'project.status.onHold',
  [ProjectLineStatus.Done]: 'project.status.done',
};

interface Props {
  line: ProjectLine;
}

const StatusCell = ({ line }: Props) => {
  return (
    <Box className={cx(styles['status-cell'], styles[`status--${line.status}`])}>
      {translate(STATUS_MAP[line.status])}
    </Box>
  );
};

export default StatusCell;
